export default __webpack_public_path__ + "static/media/gauntlets_of_the_wicked.82b79327.jpg";